"use client";

import { Box, Typography } from "@repo/ui";
import Image from "next/image";

const NoScheduleScreen = () => {
  return (
    <Box className="grid place-content-center">
      <Box className="text-center">
        <Image
          src="/images/no-schedule.png"
          width={432}
          height={288}
          alt="no-schedule"
          quality={100}
        />
        <Typography variant="h4">No Schedule at your Location.</Typography>
      </Box>
    </Box>
  );
};

export default NoScheduleScreen;
